module.exports = __webpack_public_path__ + "img/villa_dialog_icon06.c4a3855d.png";